<div class="dialog-header">
  @if (entry.category === Category.EMAIL) {
    <div class="dialog-header__icon-wrap">
      <mat-icon class="dialog-header__icon">forward_to_inbox</mat-icon>
    </div>
  }
  <div class="dialog-header__text">
    <span class="dialog-header__title">{{
      'ADMIN.DAYS_LEFT.EVENT_TYPE.' + entry.eventType | translate
    }}</span>
    <span class="dialog-header__subtitle">{{
      entry.eventTimestamp | date: 'dd MMM yyyy · HH:mm'
    }}</span>
  </div>
  <span
    class="dialog-header__badge"
    [class.dialog-header__badge--success]="entry.result === Result.SUCCESS"
    [class.dialog-header__badge--error]="entry.result === Result.ERROR"
  >
    {{ entry.result }}
  </span>
</div>

<mat-dialog-content>
  @if (entry.sentEmails?.length) {
    <div class="section-label section-label--success">
      <mat-icon class="section-label__icon">group</mat-icon>
      {{ 'ADMIN.DAYS_LEFT.DETAIL_SENT' | translate: { count: entry.sentEmails!.length } }}
    </div>
    <ul class="email-list">
      @for (email of entry.sentEmails; track email) {
        <li class="email-list__item">
          <mat-icon class="email-list__icon">alternate_email</mat-icon>
          <span>{{ email }}</span>
        </li>
      }
    </ul>
  }

  @if (entry.failedEmails?.length) {
    <div class="section-label section-label--error">
      <mat-icon class="section-label__icon">error_outline</mat-icon>
      {{ 'ADMIN.DAYS_LEFT.DETAIL_FAILED' | translate: { count: entry.failedEmails!.length } }}
    </div>
    <ul class="email-list">
      @for (email of entry.failedEmails; track email) {
        <li class="email-list__item">
          <mat-icon class="email-list__icon">alternate_email</mat-icon>
          <div class="email-list__content">
            <span>{{ email }}</span>
            @if (failureReasonByEmail.get(email)) {
              <span class="email-list__reason">{{ failureReasonByEmail.get(email) }}</span>
            }
          </div>
        </li>
      }
    </ul>
  }

  @if (!entry.sentEmails?.length && !entry.failedEmails?.length && entry.result !== Result.ERROR) {
    <p class="empty-state">{{ 'ADMIN.DAYS_LEFT.DETAIL_NO_RECIPIENTS' | translate }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    {{ 'SHARED.DIALOGS.DIALOG.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
